import * as yup from 'yup'
import { getNameSchema, getPhoneSchema } from 'src/deps'

export const getRecipientSchema = () =>
  yup.object({
    ...getNameSchema({ inputName: 'recipientName', isRecipientName: true }),
    ...getPhoneSchema(),
  })
